import React from 'react'
import { Col, Image } from 'react-bootstrap'
import { FaLink } from 'react-icons/fa'
import OpenNewTab from '../hooks/OpenNewTab'
import { NavLink } from 'react-router-dom'


const Project = (props) => {
    const { openInNewTab } = OpenNewTab()

    return (
        <Col lg={4} md={6} className="portfolio-item px-3" data-aos="fade-down">
            <div className="portfolio-inner rounded">
                <Image className="img-fluid w-100" src={"asset/img/projects/" + props.img} alt={props.title} style={{ height: "200px" }} />
                <div className="portfolio-text">
                    <h4 className="text-white mb-4 text-center">{props.title}</h4>
                    <div className="d-flex">
                        <NavLink className="btn btn-lg-square rounded-circle mx-2" to="" onClick={(e) => openInNewTab(props.link)}><i><FaLink /></i></NavLink>
                    </div>
                </div>
            </div>
        </Col>
    )
}

export default Project